/* Copyright 2017-2020 The MathWorks, Inc. */
define([
    'dojo/_base/declare',
    'dgrid/OnDemandGrid',
    'dgrid/Selection',
    'dgrid/Keyboard',
    'dgrid/extensions/ColumnResizer',
    'dgrid/extensions/ColumnHider',
    'dgrid/extensions/DijitRegistry'
], function (declare,
    OnDemandGrid,
    Selection,
    Keyboard,
    ColumnResizer,
    ColumnHider,
    DijitRegistry) {
    return declare([OnDemandGrid, Selection, Keyboard, ColumnResizer, ColumnHider, DijitRegistry], {});
});
